<div class="section-header" [ngClass]="{ 'no-margin':!tableHasRequestedItems()}">
    <div class="title">
        <span>{{title}}</span>
        <app-info-icon-button *ngIf="isInfoIconVisible()" [model]="{ title: 'Information',
                              messages: [getInfoIconText()],
                              dialogHeight: 100}">
        </app-info-icon-button>
    </div>




    <div class="button-container">
        <app-amount-input [ngModel]="model.someAccessoryTableContainerIsActive"
                          *ngIf="tableId === MyContainersTableIdEnum.step4AccessoriesTableContainers"
                          [showIcon]="false"
                          [name]="'someAccessoryTableContainerIsActive'"
                          [bdMinNumber]="1"
                          class="validator-helper">
        </app-amount-input>
        <app-amount-input [ngModel]="model.someWarrantyTableContainerIsActive"
                          *ngIf="tableId === MyContainersTableIdEnum.step4WarrantiesTableContainers"
                          [showIcon]="false"
                          [name]="'someWarrantyTableContainerIsActive'"
                          [bdMinNumber]="1"
                          class="validator-helper">
        </app-amount-input>

        <app-amount-input [ngModel]="model.someUpgradesTableContainerIsActive"
                          *ngIf="tableId === MyContainersTableIdEnum.step4UpgradesContainers"
                          [showIcon]="false"
                          [name]="'someUpgradesTableContainerIsActive'"
                          [bdMinNumber]="1"
                          class="validator-helper">
        </app-amount-input>




        <div class="no-hardware-btn" (click)="onRemoveItemsFromOrderBtnLicked()"
             [ngClass]="{'invalid':(forceFormValidationVisibility|| model.isStep4ButtonsValidationVisibilityForced) && !(tableItems?.length)}">
            Nichts hinzufügen
        </div>

        <button (click)="onAddProductBtnClicked()" class="btn-add-device" type="button"
                [ngClass]="{'invalid' : (forceFormValidationVisibility|| model.isStep4ButtonsValidationVisibilityForced)  && !projectRowItemsAmountComplyRules()}">
            <bd-fa-button [name]="activeSpinnerId === spinnerId ? 'refresh fa-spin' : 'plus'">
            </bd-fa-button>
            <span>Artikel hinzufügen</span>
        </button>
    </div>


    <!--    <bd-input-error-viewer [ngModelRef]="validationHelperNgModel"-->
    <!--                           [customErrorsMsg]="{'isBdMinNumber': 'Bitte wählen Sie mindestens ein Gerät oder Verbrauchsmaterial aus.'}"-->
    <!--                           class="error-viewer">-->
    <!--    </bd-input-error-viewer>-->

</div>


<ng-container *ngIf="tableHasRequestedItems()">


    <div class="table">
        <div class="table-header" [ngClass]="{'notify-change' : notifyAdditionalItemsTableChange()}">
            <div class="table-header-column">Anzahl</div>
            <div class="table-header-column">Artikel</div>
        </div>

        <div class="table-body">

            <ng-container *ngIf="tableHasRequestedItems()">
                <div class="table-row not-device"
                     *ngFor="let tableItem of tableItems">
                    <ng-container
                        *ngTemplateOutlet="notDeviceContainerTemplate; context:{itemContainer: tableItem}">
                    </ng-container>
                </div>
            </ng-container>
        </div>

    </div>
</ng-container>


<ng-template #notDeviceContainerTemplate let-itemContainer="itemContainer">

    <div class="amount-column-cell">
        <app-amount-input [(ngModel)]="itemContainer.waAcLsAmount.amount" [incrementViaMouseWheel]="false"
                          [showIcon]="false" [name]="itemContainer.id + 'amount_datc'" [bdMinNumber]="1" [minNumber]="0"
                          [forceFormValidationVisibility]="forceFormValidationVisibility" required
                          #dynamicInput="ngModel">
        </app-amount-input>


    </div>
    <div class="article-column-cell">
        <div class="product-label-container">
            <app-product-label [orderItemContainer]="itemContainer"></app-product-label>
        </div>
    </div>


    <div class="button-cell">
        <button (click)="onRemoveItemBtnClicked( itemContainer )" type="button">
            <bd-fa-button [name]="'times'"></bd-fa-button>
        </button>
    </div>
</ng-template>
